import { BaseEnum } from "./baseEnum";

const listWorkRegimeEnum: Array<WorkforceplanMovementType> = [];

export class WorkforceplanMovementType extends BaseEnum {
	static WORK_FORCEPLAN = new WorkforceplanMovementType(
		1,
		"WorkforcePlanning",
		"Planejamento de Orgânico"
	);
	static TRAINNING = new WorkforceplanMovementType(
		2,
		"InternalTraining",
		"Solicitação de Treinamento"
	);
	static DISMISSAL = new WorkforceplanMovementType(
		3,
		"Dismissal",
		"Demissional"
	);
	static SHIFT_CHANGE = new WorkforceplanMovementType(
		4,
		"ShiftChange",
		"Troca de turno"
	);
	static NEW_HIRING_SUBSTITUTION = new WorkforceplanMovementType(
		5,
		"NewHiringSubstitution",
		"Nova Contratação (Substituição)"
	);
	static COST_CENTER_AND_JOB_TITLE_CHANGE = new WorkforceplanMovementType(
		6,
		"CostCenterAndJobTitleChange",
		"Troca de Centro de Custo/Função"
	);
	static JOB_TITLE_CHANGE = new WorkforceplanMovementType(
		7,
		"JobTitleChange",
		"Troca de cargo"
	);
	static NEW_HIRING_INCREASE = new WorkforceplanMovementType(
		8,
		"NewHiringIncrease",
		"Nova Contratação (Aumento de quadro)"
	);
	static DISCIPLINARY_MEASURE = new WorkforceplanMovementType(
		9,
		"DisciplinaryMeasure",
		"Medida Disciplinar"
	);
	static NEW_HIRING_REPLACEMENT = new WorkforceplanMovementType(
		10,
		"NewHiringReplacement",
		"Nova Contratação (Reposição)"
	);
	static NEW_REQUEST_FEEDBACKS = new WorkforceplanMovementType(
		10,
		"NewRequestFeedbacks",
		"Solicitação de Feedback"
	);
	static PROBATION_PERIOD = new WorkforceplanMovementType(
		11,
		"ProbationPeriod",
		"Período de Experiência"
	);
	static APTITUDE_TRAINNING = new WorkforceplanMovementType(
		12,
		"AptitudeTraining",
		"Solicitação de Treinamento de Aptidão"
	);
	static PROMOTION = new WorkforceplanMovementType(
		13,
		"Promotion",
		"Promoção"
	);

	constructor(public id: number, public value: string, public label: string) {
		super(id, value, label);

		listWorkRegimeEnum.push(this);
	}

	public static buildListEnum(): Array<BaseEnum> {
		return listWorkRegimeEnum;
	}

	public static getByEnumerator(value: string) {
		switch (value) {
			case "REQUEST_DISMISSAL":
				return this.getBy("Dismissal");
			case "REQUEST_TRAINING":
				return this.getBy("InternalTraining");
			case "REQUEST_APTITUDE_TRAINING":
				return this.getBy("AptitudeTraining");
			case "SHIFT_CHANGE":
				return this.getBy("ShiftChange");
			case "REQUEST_HIRING_SUBSTITUTION":
				return this.getBy("NewHiringSubstitution");
			case "COST_CENTER_AND_JOB_TITLE_CHANGE":
				return this.getBy("CostCenterAndJobTitleChange");
			// case "JOBTITLE_CHANGE":
			// 	return this.getBy("JobTitleChange");
			case "REQUEST_HIRING_INCREASE":
				return this.getBy("NewHiringIncrease");
			case "REQUEST_WORK_FORCEPLAN":
				return WorkforceplanMovementType.getBy("WorkforcePlanning");
			case "REQUEST_HIRING_REPLACEMENT":
				return this.getBy("NewHiringReplacement");
			case "REQUEST_FEEDBACK":
				return this.getBy("NewRequestFeedbacks");
			case "REQUEST_DISCIPLINARY_MEASURE":
				return WorkforceplanMovementType.getBy(
					WorkforceplanMovementType.DISCIPLINARY_MEASURE.value
				);
			case "REQUEST_PROMOTION":
				return this.getBy("Promotion");
		}
	}

	public static getByAny(value: unknown): WorkforceplanMovementType | undefined {
		if (typeof value === "number") {
			return this.getById(value) as WorkforceplanMovementType | undefined;
		}

		if (typeof value === "string") {
			const numericValue = Number(value);
			if (!Number.isNaN(numericValue) && value.trim() !== "") {
				return this.getById(numericValue) as WorkforceplanMovementType | undefined;
			}

			return this.getBy(value) as WorkforceplanMovementType | undefined;
		}

		return undefined;
	}
}
